// extracted by mini-css-extract-plugin
export default {"spinner":"pure-circular-progress_spinner__Blwst"};